<template>
    <div class="ComGrid">
        <div class="container" :style="{ gridTemplateColumns: columns }">
            <div v-for="(item, index) in List" :key="index" class="grid_piece"
                :style="{ backgroundImage: `url(${item.bg || bg})` }">
                <div>{{ $t(item.title) }}</div>
                <div class="mt-1 grid_font">{{ item.value || '0' }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ComGrid',
    props: {
        cols: {
            type: Number,
            default: 2,
        },
        bg: {
            type: String,
            default: '',
        },
        List: {
            type: Array,
            default: [],
        },
    },
    computed: {
        columns() {
            return `repeat(${this.cols}, 1fr)`; // 动态计算列数
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>